import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-coursenavbar',
  templateUrl: './coursenavbar.component.html',
  styleUrls: ['./coursenavbar.component.css']
})
export class CoursenavbarComponent implements OnInit {

  constructor(
    public authService: AuthService
  ) { }

  ngOnInit(): void {
  }

}
